// action - state management
import { LOGIN, LOGOUT, REGISTER, ENABLE_OTP } from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const accountReducer = (state, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user,
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
      };
    }
    case ENABLE_OTP: {
      const { cellPhone, registryNo, pwd } = action.payload;

      return {
        ...state,
        cellPhone,
        registryNo,
        pwd,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
